import { useEffect, useState } from "react";
import {
  GetMyCompanyAccelerator,
  GetMyCompanyAcceleratorByBatchId,
  GetMyCompanyAcceleratorsReciver,
} from "../../../services/CompanyService";
import { Avatar, Button, Modal, Table, Tabs, Tag, Tooltip } from "antd";
import ConvertToShamsi from "../../../extentions/convertors/ConvertToShamsi";
import { ColumnsType } from "antd/es/table";
import { GetViews, GetViewsId } from "../../../services/NoticeService";
import { useNavigate } from "react-router-dom";
import { CreateGroup } from "../../../services/MessagingService";
import CustomButton from "../../share/customButton";
import {
  FolderViewOutlined,
  InsertRowAboveOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import { GetInvitationByInvitationId } from "../../../services/InvitationService";
import SentAccelerators from "./SentAccelerators";

const RecivedAccelerators = () => {
  const navigate = useNavigate();
  const [getAcceleratorData, setAcceleratorData] = useState();
  const [getAcceleratorReciverData, setAcceleratorReciverData] = useState();

  useEffect(() => {
    GetMyCompanyAccelerator().then((p) => setAcceleratorData(p.data.data));
    GetMyCompanyAcceleratorsReciver().then((p) =>
      setAcceleratorReciverData(p.data.data)
    );
  }, []);

  async function CreateGroupAsync(Id: any) {
    //console.log("wph", `${window.location.host}/Chat`);

    //return;
    await CreateGroup({ noticeId: Id }).then(() => {
      //navigate("/chat");
      //window.parent.location.href = `http://${window.location.host}/Chat/${params.id}`;
      window.parent.location.href = `http://${window.location.host}/Chat/${Id}`;
    });
  }

  async function CreateGroupAndOpenModalAsync(Id: any) {
    //console.log("wph", `${window.location.host}/Chat`);

    //return;
    await CreateGroup({ noticeId: Id }).then(() => {
      //navigate("/chat");
      //window.parent.location.href = `http://${window.location.host}/Chat/${params.id}`;
      window.parent.location.href = `http://${window.location.host}/Chat/${Id}/1`;
    });
  }

  const columnsReciverTotal: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "#",
      key: "#",
      width: "2%",
      render: (item, record, index) => <>{index + 1}</>,
    },
    {
      title: " عنوان آگهی شتاب شده",
      dataIndex: "title",
      key: "title",
      width: "20%",
    },
    {
      title: "نوع شتاب",
      dataIndex: "accelaratorType",
      key: "accelaratorType",
      width: "20%",
      render: (item, record, index) => (
        <>{record.accelaratorType === 0 ? "پیامک" : "اعلان درون سیستمی"} </>
      ),
    },
    {
      title: "تاریخ",
      dataIndex: "createdDate",
      key: "createdDate",
      width: "20%",

      render: (item, record, index) => (
        <>{ConvertToShamsi(record.createdDate)}</>
      ),
    },
    {
      title: "",
      dataIndex: "noticeState",
      key: "noticeState",
      width: "10%",

      render: (item, record, index) => (
        <>
          <Tooltip title="   مشاهده آگهی">
            <a
              onClick={() => {
                navigate(`/notice/${record.noticeId}?tab=1`);
              }}
              className="px-2"
              style={{ border: "1px" }}
            >
              <FolderViewOutlined style={{ color: "GrayText" }} />
            </a>
          </Tooltip>
          <Tooltip title="شروع گفتگو">
            <a
              onClick={() => CreateGroupAsync(record.noticeId)}
              className="px-2"
              style={{ border: "1px" }}
            >
              <MessageOutlined style={{ color: "green" }} />
            </a>
          </Tooltip>
          <Tooltip title="قیمت دادن به این آگهی ">
            <a
              onClick={() => CreateGroupAndOpenModalAsync(record.noticeId)}
              className="px-2"
              style={{ border: "1px" }}
            >
              <InsertRowAboveOutlined style={{ color: "blue" }} />
            </a>
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <>
      <div style={{ width: "90%" }}>
        <Table
          columns={columnsReciverTotal}
          className="mt-2"
          size="small"
          dataSource={getAcceleratorReciverData}
          pagination={false}
        />
      </div>
    </>
  );
};

export default RecivedAccelerators;
